/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setDNavBtn.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ドロワーナビゲーションボタン
 */
const setDNavBtn = () => {
	var body = document.body;
	var DNavBtn = document.getElementById("d-nav-btn");
	var DNav = document.getElementById("site-h_d-nav");

	DNavBtn.addEventListener("click", function () {
		body.classList.toggle("open");
		DNavBtn.classList.toggle("open");
		DNav.classList.toggle("open");
	});
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setDNavBtn };
